
const OK = "OK";
const ERROR = "ERROR";

const Status = {
  OK,
  ERROR,
};

const SuccessResponse = payload => {
  return {
    status: OK,
    payload,
  }
};

const str_to_stack = str => {
  return str.split("\n");
}

/**
 * @param error A simple string
 * @return {{status: string, error: *}}
 */
const ErrorResponse = error => {
  if (error instanceof Error) {
    return {
      status: ERROR,
      error: error,
      exec_stacktrace: str_to_stack(error.stack),
      stacktrace: str_to_stack(new Error().stack),
    }
  }
  return {
    status: ERROR,
    error,
    stacktrace: str_to_stack(new Error().stack),
  }
};

const ToHttpResponse = (response, statusCode) => {
  if (response.status === Status.OK) {
    return {
      isBase64Encoded: false,
      statusCode: statusCode || 200,
      body: JSON.stringify(response.payload),
      headers: {
        "content-type": "application/json"
      }
    }
  }

  // Error
  return {
    isBase64Encoded: false,
    statusCode: statusCode || 500,
    body: JSON.stringify({
      stacktrace: response.stacktrace,
      error: response.error,
    }),
    headers: {
      "content-type": "application/json"
    }
  }
}

module.exports = {
  OK, ERROR, Status, SuccessResponse, ErrorResponse, ToHttpResponse,
};
